import { PropsWithChildren } from 'react';
import { FormLabel } from '@ds';
import cn from 'classnames';
import { ConditionalRender } from '@ui';

export type FormRowProps = {
  title?: string;
  isRequired?: boolean;
  multiRow?: boolean;
  spitRows?: boolean;
  wrapperClass?: string;
  labelClass?: string;
  contentClass?: string;
};

export const FormRow = ({
  title,
  isRequired,
  multiRow,
  spitRows,
  wrapperClass,
  labelClass,
  contentClass,
  children,
}: PropsWithChildren<FormRowProps>) => {
  const defaultLabelClass = 'text-base-30 flex-[28%]';
  const defaultContentClasses = cn('flex-[72%] max-w-[72%]', {
    'flex-1': !title,
    'flex-col': spitRows,
  });

  return (
    <div className={cn('flex', { 'items-center': !multiRow, 'w-full': spitRows }, wrapperClass)}>
      <ConditionalRender show={!!title}>
        <FormLabel
          className={cn(labelClass || defaultLabelClass, { 'mt-1': multiRow })}
          as="span"
          isRequired={isRequired}
        >
          {title}
        </FormLabel>
      </ConditionalRender>
      <div className={cn('flex justify-start gap-4', contentClass || defaultContentClasses)}>{children}</div>
    </div>
  );
};
